module.exports = ".contacts-area{padding:8px}\n"